module.exports = __webpack_public_path__ + "img/DE06267.a873068d.png";